var map = {
	"./Pages/Blocks.vue": 77887,
	"./Pages/Blocks2.vue": 80880,
	"./components/AlamedaUnlocks.vue": 76020,
	"./components/AutocompleteSearch.vue": 30566,
	"./components/BlockExplorer.vue": 19791,
	"./components/BlockMetricsChart.vue": 46545,
	"./components/BlockTimeDashboard.vue": 79425,
	"./components/BlockTimeSeriesChart.vue": 92488,
	"./components/BookmarkButton.vue": 3686,
	"./components/CommentForm.vue": 68310,
	"./components/Delegate.vue": 20430,
	"./components/EpochTime.vue": 46165,
	"./components/EthStake.vue": 37026,
	"./components/ExampleComponent.vue": 53221,
	"./components/FeeBurn.vue": 49446,
	"./components/FollowButton.vue": 61163,
	"./components/GradientChart.vue": 83961,
	"./components/IdleMiner.vue": 7598,
	"./components/JupiterSwap.vue": 36644,
	"./components/LeafletMap.vue": 23751,
	"./components/MarinadeForm.vue": 12712,
	"./components/MetricCard.vue": 30333,
	"./components/MevRewardsClaimer.vue": 40995,
	"./components/PageForm.vue": 5897,
	"./components/PostForm.vue": 88399,
	"./components/ProjectForm.vue": 67812,
	"./components/ProjectVoteModal.vue": 23815,
	"./components/ProjectVoteScore.vue": 36187,
	"./components/ProjectVoting.vue": 66813,
	"./components/RestartStatus.vue": 38709,
	"./components/RewardCalculator.vue": 73759,
	"./components/RichTextEditor.vue": 69268,
	"./components/SolendLoop.vue": 81913,
	"./components/StakeAccount.vue": 52124,
	"./components/StakeDashboard.vue": 51641,
	"./components/StakeDistribution.vue": 46546,
	"./components/StakeEconomy.vue": 19172,
	"./components/StakeHealth.vue": 607,
	"./components/StakeLST.vue": 45704,
	"./components/StakePoolDetails.vue": 73292,
	"./components/StakingHealthcheck.vue": 96868,
	"./components/Swap.vue": 65937,
	"./components/SwapInner.vue": 38680,
	"./components/TokenList.vue": 59814,
	"./components/TokenSelector.vue": 82641,
	"./components/TreeMap.vue": 60874,
	"./components/TurboStake.vue": 68662,
	"./components/Validators/ValidatorScore.vue": 99151,
	"./components/Validators/ValidatorsTable.vue": 73975,
	"./components/VoteButtons.vue": 82701,
	"./components/WalletButton.vue": 56745,
	"./components/WalletConnection.vue": 66078,
	"./components/defi/BorrowLend.vue": 47218,
	"./components/defi/LiquidityPools.vue": 2889,
	"./components/tvChart.vue": 73177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27373;